import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import './MainMenu.css';

export default function MainMenu() {
    const navigate = useNavigate();
    const { logout } = useAuth0();

    const items = [
        {
            label: 'VIN View',
            icon: 'pi pi-car',
            items: [
                {
                    label: 'VIN Decoder',
                    icon: 'pi pi-car',
                    command: () => navigate('/decoder')
                },
                {
                    label: 'VIN Decoder (lite)',
                    icon: 'pi pi-car',
                    command: () => navigate('/decoder-lite')
                },
                {
                    label: 'Chat Tool',
                    icon: 'pi pi-comments',
                    command: () => navigate('/chat')
                },
                {
                    label: 'VIN View Dashboard',
                    icon: 'pi pi-chart-bar',
                    command: () => navigate('/vin-dashboard')
                }
            ]
        },
        {
            label: 'Config',
            icon: 'pi pi-cog',
            items: [
                {
                    label: 'Excel upload',
                    icon: 'pi pi-file-excel',
                    command: () => navigate('/config'),
                },
                {
                    label: 'Upload sessions',
                    icon: 'pi pi-upload',
                    command: () => navigate('/sessions'),
                },
                {
                    label: 'Dashboard',
                    icon: 'pi pi-chart-bar',
                    command: () => navigate('/dashboard'),
                },
                // {
                //     label: 'VIN List',
                //     icon: 'pi pi-file-excel',
                //     command: () => navigate('/vin-list'),
                // },
            ]
        },
        {
            label: 'VIN Data Scraping',
            icon: 'pi pi-search',
            items: [
                {
                    label: 'Queue Partslink24',
                    icon: 'pi pi-car',
                    command: () => navigate('/queue-partslink'),
                },
                {
                    label: 'Queue MyRenault',
                    icon: 'pi pi-car',
                    command: () => navigate('/queue-myrenault'),
                },
            ]
        },
        {
            label: 'PDF Tools',
            icon: 'pi pi-file-pdf',
            items: [
                {
                    label: 'VIN Splitter',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-splitter'),
                },
                {
                    label: 'Renamer',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-renamer'),
                },
                {
                    label: 'Anonymizer',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-anonymizer'),
                },
                {
                    label: 'Image Extractor',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-image-extractor'),
                },
                {
                    label: 'Rebranding',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-rebranding'),
                },
                {
                    label: 'Reader',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-reader'),
                },
                {
                    label: 'Downloader',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-downloader'),
                },
                {
                    label: 'File sharing',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-sharing'),
                },
                {
                    label: 'Folder sharing',
                    icon: 'pi pi-file-pdf',
                    command: () => navigate('/pdf-folder-sharing'),
                },
            ]
        },
        {
            label: 'VWFS Imports',
            icon: 'pi pi-upload',
            command: () => navigate('/import')
        },
        {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => logout({ returnTo: window.location.origin })
        }
    ];

    return (
        <div className="card">
            <Menubar model={items} className="main-menubar" />
        </div>
    );
}